(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    // Elements
    const filterBtn = document.querySelector('[data-filter-toggle]');
    const filterDrawer = document.querySelector('[data-filter-drawer]');
    const filterBackdrop = document.querySelector('[data-filter-backdrop]');
    const filterClose = document.querySelector('[data-filter-close]');
    const filterApply = document.querySelector('[data-filter-apply]');
    const filterClear = document.querySelector('[data-filter-clear]');
    const checkboxes = document.querySelectorAll('.essence-filter-option__checkbox[data-filter-value]');
    const countDisplay = document.querySelector('[data-filter-count]');

    function openFilter() {
      if (!filterDrawer) return;
      filterDrawer.classList.add('is-open');
      filterBackdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeFilter() {
      if (!filterDrawer) return;
      filterDrawer.classList.remove('is-open');
      filterBackdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // Build Search & Discovery URL format
    function applyFilters() {
      const baseUrl = window.location.pathname;
      const params = new URLSearchParams(window.location.search);

      // Remove existing filter params to rebuild them
      const filterKeys = Array.from(params.keys()).filter((key) => key.startsWith('filter.'));
      filterKeys.forEach((key) => params.delete(key));

      // Group checked values by their param_name (e.g., filter.p.tag, filter.v.option.size)
      const activeFilters = {};

      checkboxes.forEach((cb) => {
        if (cb.checked) {
          const paramName = cb.name; // e.g., "filter.p.tag"
          if (!activeFilters[paramName]) activeFilters[paramName] = [];
          activeFilters[paramName].push(cb.value);
        }
      });

      // Add to URLSearchParams
      Object.keys(activeFilters).forEach((paramName) => {
        // Search & Discovery format: ?filter.p.tag=value1,value2
        params.set(paramName, activeFilters[paramName].join(','));
      });

      const queryString = params.toString();
      window.location.href = queryString ? `${baseUrl}?${queryString}` : baseUrl;
    }

    // Restore state from URL on page load
    function restoreFilterState() {
      const params = new URLSearchParams(window.location.search);
      let activeCount = 0;

      // Check boxes based on URL params
      checkboxes.forEach((cb) => {
        const paramName = cb.name;
        const paramValue = params.get(paramName);

        if (paramValue) {
          const activeValues = paramValue.split(',');
          if (activeValues.includes(cb.value)) {
            cb.checked = true;
            cb.closest('.essence-filter-option').classList.add('is-active');
            activeCount++;
          }
        }
      });

      updateFilterCount(activeCount);
    }

    function updateFilterCount(specificCount) {
      let count;
      if (typeof specificCount === 'number') {
        count = specificCount;
      } else {
        count = document.querySelectorAll('.essence-filter-option__checkbox:checked').length;
      }

      if (countDisplay) {
        countDisplay.textContent = count > 0 ? `(${count})` : '+';
      }

      if (filterBtn && !countDisplay) {
        filterBtn.textContent =
          count > 0
            ? `{{ 'sections.collection.filter' | t | upcase }} (${count})`
            : `{{ 'sections.collection.filter' | t | upcase }} +`;
      }
    }

    // Event Listeners
    if (filterBtn) filterBtn.addEventListener('click', openFilter);
    if (filterClose) filterClose.addEventListener('click', closeFilter);
    if (filterBackdrop) filterBackdrop.addEventListener('click', closeFilter);
    if (filterApply) filterApply.addEventListener('click', applyFilters);

    if (filterClear) {
      filterClear.addEventListener('click', (e) => {
        e.preventDefault();
        window.location.href = window.location.pathname; // Remove all query params
      });
    }

    // Update UI on checkbox change
    checkboxes.forEach((cb) => {
      cb.addEventListener('change', function () {
        this.closest('.essence-filter-option').classList.toggle('is-active', this.checked);
        updateFilterCount();
      });
    });

    // Initialize
    restoreFilterState();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["essence-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var container = document.querySelector('[data-hero-carousel]');
    if (!container) return;

    var slides = container.querySelectorAll('.essence-hero__slide');
    if (slides.length <= 1) return;

    var currentIndex = 0;
    var intervalTime = 5000;
    var timer;

    function nextSlide() {
      slides[currentIndex].classList.remove('is-active');
      currentIndex = (currentIndex + 1) % slides.length;
      slides[currentIndex].classList.add('is-active');
    }

    timer = setInterval(nextSlide, intervalTime);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-essence"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      const expandBtn = document.querySelector('[data-faq-expand-all]');
      if(expandBtn) {
          expandBtn.addEventListener('click', function() {
              const details = document.querySelectorAll('.essence-faq__item');
              const isExpanded = this.getAttribute('data-expanded') === 'true';
              
              details.forEach(detail => {
                  if(isExpanded) {
                      detail.removeAttribute('open');
                  } else {
                      detail.setAttribute('open', '');
                  }
              });
              
              this.textContent = isExpanded ? 'EXPAND ALL' : 'COLLAPSE ALL';
              this.setAttribute('data-expanded', !isExpanded);
          });
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.querySelector('[data-header]');
    var lastY = window.scrollY || 0;
    var ticking = false;

    // Detect if we are on Home Page (Transparent) or Inner (Light)
    var isHome = header && header.classList.contains('header--transparent');

    function updateHeader() {
        var currentY = window.scrollY || 0;
        
          // 1. Toggled Class on Scroll > 10px (Solid Background)
          if (currentY > 10) {
            // Scrolled: force solid header and clear hover state
            header.classList.add('header--toggled');
            header.classList.remove('header--hovered');
          } else {
            // At top: remove toggled. Show hovered state only if mouse is over header or mobile menu is open.
            header.classList.remove('header--toggled');
            if (header.matches(':hover') || document.body.classList.contains('is-mobile-menu-open')) {
             header.classList.add('header--hovered');
            } else {
             header.classList.remove('header--hovered');
            }
          }

        // 2. Hide/Show on Scroll Logic (Smart Scroll)
        // Scroll Down -> Hide
        // Scroll Up -> Show
        if (currentY > lastY && currentY > 100) { 
             // Scrolling Down
             header.classList.add('header--hidden');
             header.classList.remove('header--visible');
        } else if (currentY < lastY) {
             // Scrolling Up
             header.classList.remove('header--hidden');
             header.classList.add('header--visible');
        }

        lastY = currentY > 0 ? currentY : 0;
        ticking = false;
    }

    if (header) {
        window.addEventListener('scroll', function() {
            if (!ticking) {
                window.requestAnimationFrame(updateHeader);
                ticking = true;
            }
        }, {passive: true});

        // Hover Behavior: use a separate hovered class so scroll-toggled state remains distinct
        header.addEventListener('mouseenter', function() {
          header.classList.add('header--hovered');
        });
        
        header.addEventListener('mouseleave', function() {
           var currentY = window.scrollY || 0;
           if (currentY <= 10) {
             header.classList.remove('header--hovered');
           }
        });
    }

    // Search Toggle
    const searchBtn = document.querySelector('[data-search-toggle]');
    const searchOverlay = document.querySelector('[data-search-overlay]');
    const searchClose = document.querySelector('[data-search-close]');
    
    if (searchBtn && searchOverlay) {
        // Handle multiple search buttons (desktop + mobile)
        document.querySelectorAll('[data-search-toggle]').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                searchOverlay.classList.add('is-open');
                const input = searchOverlay.querySelector('input');
                if(input) setTimeout(() => input.focus(), 300);
            });
        });

        if (searchClose) searchClose.addEventListener('click', () => searchOverlay.classList.remove('is-open'));
    }

    // Cart Drawer Toggle
    const cartBtns = document.querySelectorAll('[data-cart-toggle]');
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    const cartBackdrop = document.querySelector('[data-cart-close].cart-drawer-backdrop');
    const cartCloses = document.querySelectorAll('[data-cart-close]');
    
    if (cartDrawer && cartBackdrop) {
        cartBtns.forEach(btn => btn.addEventListener('click', (e) => {
            e.preventDefault();
            cartDrawer.classList.add('is-open');
            cartBackdrop.classList.add('is-open');
        }));
        
        cartCloses.forEach(btn => btn.addEventListener('click', () => {
            cartDrawer.classList.remove('is-open');
            cartBackdrop.classList.remove('is-open');
        }));
    }

    // Mobile Menu
    const mobileToggle = document.querySelector('[data-mobile-toggle]');
    const mobileClose = document.querySelector('[data-mobile-close]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    
    function toggleMenu() {
        if(!mobileMenu) return;
        const isOpen = mobileMenu.classList.contains('is-open'); // Check current state
        if(isOpen) {
            // Close
            mobileMenu.classList.remove('is-open');
            document.body.classList.remove('is-mobile-menu-open');
        // fallback: remove inline overrides
        mobileMenu.style.display = '';
        mobileMenu.style.opacity = '';
        mobileMenu.style.visibility = '';
        } else {
            // Open
            mobileMenu.classList.add('is-open');
            document.body.classList.add('is-mobile-menu-open');
        // fallback: ensure visible even if CSS has issues
        mobileMenu.style.display = 'block';
        mobileMenu.style.opacity = '1';
        mobileMenu.style.visibility = 'visible';
        }
    }
    
    if(mobileToggle) {
      mobileToggle.addEventListener('click', toggleMenu);
      mobileToggle.addEventListener('touchstart', function(e){ e.preventDefault(); toggleMenu(); });
    }
    if(mobileClose) {
      mobileClose.addEventListener('click', toggleMenu);
      mobileClose.addEventListener('touchstart', function(e){ e.preventDefault(); toggleMenu(); });
    }

    // Submenus
    const subTriggers = document.querySelectorAll('[data-mobile-sub-trigger]');
    subTriggers.forEach(trigger => {
        trigger.addEventListener('click', function() {
            const id = this.getAttribute('data-mobile-sub-trigger');
            const target = document.querySelector(`[data-mobile-sub-target="${id}"]`);
            if(target) target.classList.add('is-open');
        });
    });

    const subBacks = document.querySelectorAll('[data-mobile-sub-back]');
    subBacks.forEach(btn => {
        btn.addEventListener('click', function() {
            this.closest('.mobile-menu__submenu').classList.remove('is-open');
        });
    });
    // --- Cart AJAX & Quantity Logic ---
    window.refreshCart = function() {
      fetch(`${window.location.pathname}?section_id=header`)
        .then(response => response.text())
        .then(text => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          
          const newCartItems = html.querySelector('[data-cart-items]');
          const newCartFooter = html.querySelector('[data-cart-footer]');
          const newCartCount = html.querySelector('[data-cart-count]');
          const newHeaderCartDot = html.querySelector('.header__cart-dot');

          if (newCartItems) document.querySelector('[data-cart-items]').innerHTML = newCartItems.innerHTML;
          if (newCartFooter) document.querySelector('[data-cart-footer]').innerHTML = newCartFooter.innerHTML;
          
          if (newCartCount) {
             const desktopCount = document.querySelector('[data-cart-count]');
             if(desktopCount) desktopCount.innerHTML = newCartCount.innerHTML;
          }
          
          const currentDot = document.querySelector('.header__cart-dot');
          if (newHeaderCartDot) {
            if(!currentDot) {
               const mobileCartBtn = document.querySelector('.header__actions--mobile [data-cart-toggle]');
               if(mobileCartBtn) mobileCartBtn.insertAdjacentHTML('beforeend', '<div class="header__cart-dot"></div>');
            }
          } else if (currentDot) {
            currentDot.remove();
          }
          
          initCartEvents(); // Re-attach events to new elements
        });
    };

    function updateQuantity(id, qty, inputElement) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty })
      })
      .then(response => response.json())
      .then(() => {
        window.refreshCart();
      })
      .catch(error => {
        console.error('Error updating cart:', error);
        // Revert if error? For now just refresh to sync state
        window.refreshCart();
      });
    }

    function initCartEvents() {
      const cartContainer = document.querySelector('[data-cart-drawer]');
      if (!cartContainer) return;

      // Quantity Change Delegation
      cartContainer.onclick = (e) => {
        const qtyBtn = e.target.closest('[data-qty-change]');
        if (qtyBtn) {
          const input = qtyBtn.parentElement.querySelector('.cart-drawer__qty-input');
          const id = input.dataset.id;
          const change = parseInt(qtyBtn.dataset.qtyChange);
          const currentQty = parseInt(input.value);
          const newQty = Math.max(0, currentQty + change);
          
          // --- Optimistic Update ---
          input.value = newQty; 
          if (newQty === 0) {
            qtyBtn.closest('.cart-drawer__item').style.opacity = '0.5'; // Visual cue for removal
          }
          
          updateQuantity(id, newQty, input);
        }

        const removeBtn = e.target.closest('[data-remove-item]');
        if (removeBtn) {
          e.preventDefault();
          const item = removeBtn.closest('.cart-drawer__item');
          item.style.opacity = '0.5';
          updateQuantity(item.dataset.id, 0);
        }
      };

      cartContainer.onchange = (e) => {
        const input = e.target.closest('.cart-drawer__qty-input');
        if (input) {
          updateQuantity(input.dataset.id, parseInt(input.value), input);
        }
      };
    }

    initCartEvents();

    // Ensure header matches state when mega-menus / dropdowns / menus are opened
    // Desktop: when mega-menu or dropdown is visible via hover or keyboard, show hovered state
    var navItems = document.querySelectorAll('.header__nav-item');
    navItems.forEach(function(navItem) {
      // Hover
      navItem.addEventListener('mouseenter', function() {
        // Only apply hovered style if not scrolled (toggled)
        if (!header.classList.contains('header--toggled')) header.classList.add('header--hovered');
      });
      navItem.addEventListener('mouseleave', function() {
        var currentY = window.scrollY || 0;
        if (currentY <= 10) header.classList.remove('header--hovered');
      });

      // Keyboard focus support on links
      var link = navItem.querySelector('.header__nav-link');
      if (link) {
        link.addEventListener('focus', function() {
          if (!header.classList.contains('header--toggled')) header.classList.add('header--hovered');
        });
        link.addEventListener('blur', function() {
          var currentY = window.scrollY || 0;
          if (currentY <= 10) header.classList.remove('header--hovered');
        });
      }
    });

    // When mobile menu opens, ensure header shows solid background for clarity
    var observedMobileMenu = document.querySelector('[data-mobile-menu]');
    if (observedMobileMenu) {
      var observer = new MutationObserver(function() {
        if (observedMobileMenu.classList.contains('is-open')) {
          var currentY = window.scrollY || 0;
          // If page is scrolled, keep solid (toggled). Otherwise use hovered translucent.
          if (currentY > 10) {
            header.classList.add('header--toggled');
          } else {
            header.classList.add('header--hovered');
          }
        } else {
          var currentY = window.scrollY || 0;
          header.classList.remove('header--hovered');
          if (currentY <= 10) header.classList.remove('header--toggled');
        }
      });
      observer.observe(observedMobileMenu, { attributes: true, attributeFilter: ['class'] });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length > 0) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    const productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection) {
      const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 400px 0px' });
      observer.observe(productRecommendationsSection);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // --- Selectors & Drawers logic ---
    const variantInput = document.querySelector('input[name="id"]');
    const productEl = document.querySelector('.product');
    let productVariants = [];
    try {
      if (productEl && productEl.dataset && productEl.dataset.productVariants) {
        productVariants = JSON.parse(productEl.dataset.productVariants || '[]');
      }
    } catch (e) {
      productVariants = [];
    }
    const backdrop = document.querySelector('.product-drawer-backdrop');
    const allDrawers = document.querySelectorAll('.product-drawer');
    const body = document.body;

    function bringImageToFront(index) {
      const scroller = document.querySelector('.product__gallery-scroller');
      if (!scroller) return;
      const target = document.querySelector('.product__image[data-index="' + index + '"]');
      if (!target) return;
      // Move node to be first child
      scroller.insertBefore(target, scroller.firstChild);
      // Recompute indices
      const images = scroller.querySelectorAll('.product__image');
      images.forEach((img, i) => {
        img.setAttribute('data-index', i);
      });
      // Ensure first image has active class
      images.forEach((img) => img.classList.remove('active'));
      if (images[0]) images[0].classList.add('active');
      // Update dots
      const dots = document.querySelectorAll('.product__gallery-dot');
      if (dots && dots.length > 0) {
        dots.forEach((d, i) => d.classList.toggle('active', i === 0));
      }
    }

    function goToImageIndex(index) {
      const target = document.querySelector('.product__image[data-index="' + index + '"]');
      if (!target) return;
      const scroller = document.querySelector('.product__gallery-scroller');
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      if (isMobile) {
        if (scroller && typeof target.scrollIntoView === 'function') {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
        return;
      }

      // Desktop: move the chosen image to the front so it becomes the first gallery image
      bringImageToFront(index);
    }

    function updateGalleryForVariant(variantId) {
      if (!variantId) return;
      const imgs = document.querySelectorAll('.product__image');
      for (const img of imgs) {
        const ids = (img.getAttribute('data-variant-ids') || '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean);
        if (ids.includes(String(variantId))) {
          const idx = img.getAttribute('data-index');
          goToImageIndex(idx);
          return;
        }
      }
      // fallback: try to find variant's featured_image src and match by image src
      const variant = productVariants.find((v) => String(v.id) === String(variantId));
      if (variant && variant.featured_image && variant.featured_image.src) {
        const src = variant.featured_image.src;
        for (const img of document.querySelectorAll('.product__image img')) {
          if (img.src && img.src.indexOf(src) !== -1) {
            const parent = img.closest('.product__image');
            if (parent) {
              goToImageIndex(parent.getAttribute('data-index'));
              return;
            }
          }
        }
      }
    }

    function openDrawer(drawer) {
      if (!drawer) return;
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      body.style.overflow = 'hidden';
    }

    function closeAllDrawers() {
      // Close Product drawers
      allDrawers.forEach((d) => d.classList.remove('is-open'));
      if (backdrop) backdrop.classList.remove('is-open');

      // Close Size Chart
      const scDrawer = document.querySelector('[data-size-chart-drawer]');
      const scBackdrop = document.querySelector('.size-chart-backdrop');
      if (scDrawer) scDrawer.classList.remove('is-open');
      if (scBackdrop) scBackdrop.classList.remove('is-open');

      // Close Cart Drawer
      const cartDrawer = document.querySelector('[data-cart-drawer]');
      const cartBackdropElement = document.querySelector('.cart-drawer-backdrop');
      if (cartDrawer) cartDrawer.classList.remove('is-open');
      if (cartBackdropElement) cartBackdropElement.classList.remove('is-open');

      body.style.overflow = '';
    }

    // --- Drawer Triggers ---
    const colorTrigger = document.querySelector('[data-color-drawer-trigger]');
    if (colorTrigger)
      colorTrigger.addEventListener('click', () => openDrawer(document.querySelector('[data-color-drawer]')));

    const sizeTrigger = document.querySelector('[data-size-drawer-trigger]');
    if (sizeTrigger)
      sizeTrigger.addEventListener('click', () => openDrawer(document.querySelector('[data-size-drawer]')));

    const scTrigger = document.querySelector('[data-size-chart-trigger]');
    if (scTrigger) {
      scTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        const scDrawer = document.querySelector('[data-size-chart-drawer]');
        const scBackdrop = document.querySelector('.size-chart-backdrop');
        if (scDrawer) scDrawer.classList.add('is-open');
        if (scBackdrop) scBackdrop.classList.add('is-open');
        body.style.overflow = 'hidden';
      });
    }

    // --- Option Selection Logic ---
    document.querySelectorAll('[data-drawer-option]').forEach((opt) => {
      opt.addEventListener('click', function () {
        if (this.classList.contains('disabled')) return;

        const value = this.getAttribute('data-value');
        const type = this.getAttribute('data-option-type');
        const id = this.getAttribute('data-variant-id');

        if (type === 'size') {
          const sizeDisplay = document.querySelector('[data-selected-size]');
          const sizeTrigger = document.querySelector('[data-size-drawer-trigger]');
          const atcBtn = document.querySelector('[data-atc-button]');

          if (sizeDisplay) sizeDisplay.textContent = value.toUpperCase();
          if (sizeTrigger) sizeTrigger.removeAttribute('data-no-selection');
          if (atcBtn) {
            atcBtn.disabled = false;
            atcBtn.textContent = atcBtn.dataset.defaultText;
          }
          if (variantInput && id) {
            variantInput.value = id;
            updateGalleryForVariant(id);
          }

          // Mark as selected in drawer
          document
            .querySelectorAll('.product-drawer--size .product-drawer__option')
            .forEach((o) => o.classList.remove('selected'));
          this.classList.add('selected');
        } else if (type === 'color') {
          const colorDisplay = document.querySelector('[data-color-drawer-trigger] .product__selector-value');
          if (colorDisplay) colorDisplay.textContent = value.toUpperCase();

          document
            .querySelectorAll('.product-drawer--color .product-drawer__option')
            .forEach((o) => o.classList.remove('selected'));
          this.classList.add('selected');

          // Try to resolve a variant that matches this color and current selections
          const selectors = Array.from(document.querySelectorAll('.product__selector--option'));
          const currentSelections = selectors.map((s) => {
            const valEl = s.querySelector('.product__selector-value');
            return valEl ? valEl.textContent.trim() : '';
          });

          // Determine probable option index for color
          let colorOptionIndex = null;
          selectors.forEach((s, i) => {
            const label = s.querySelector('.product__selector-label');
            if (label && label.textContent.trim().toLowerCase().indexOf('color') !== -1) colorOptionIndex = i;
          });

          if (colorOptionIndex === null) {
            for (let i = 0; i < (productVariants[0] ? productVariants[0].options.length : 0); i++) {
              if (productVariants.some((v) => (v.options[i] || '').toString().toLowerCase() === value.toLowerCase())) {
                colorOptionIndex = i;
                break;
              }
            }
          }

          if (colorOptionIndex !== null) {
            currentSelections[colorOptionIndex] = value;
            const found = productVariants.find((v) => {
              return currentSelections.every((sel, i) => {
                if (!sel || sel === '-') return true;
                return (v.options[i] || '').toString().toUpperCase() === sel.toString().toUpperCase();
              });
            });
            if (found && found.id) {
              if (variantInput) variantInput.value = found.id;
              updateGalleryForVariant(found.id);
            }
          }
        }

        closeAllDrawers();
      });
    });

    // --- AJAX Add to Cart Logic ---
    const productForm = document.querySelector('.product-form');
    const atcButton = document.querySelector('[data-atc-button]');

    if (productForm) {
      productForm.addEventListener('submit', (e) => {
        e.preventDefault();

        const originalText = atcButton.textContent;
        const addingText = atcButton.dataset.addingText || 'ADDING...';

        atcButton.textContent = addingText;
        atcButton.disabled = true;

        const formData = new FormData(productForm);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            atcButton.textContent = 'ADDED TO BAG';

            if (window.refreshCart) window.refreshCart();

            const cartDrawer = document.querySelector('[data-cart-drawer]');
            const cartBackdropElement = document.querySelector('.cart-drawer-backdrop');
            const cartDrawerDismissed = sessionStorage.getItem('cartDrawerDismissed');

            if (!cartDrawerDismissed && cartDrawer) {
              cartDrawer.classList.add('is-open');
              if (cartBackdropElement) cartBackdropElement.classList.add('is-open');
              body.style.overflow = 'hidden';
            }

            setTimeout(() => {
              atcButton.textContent = originalText;
              atcButton.disabled = false;
            }, 2000);
          })
          .catch((error) => {
            console.error('Error adding to cart:', error);
            atcButton.textContent = 'ERROR';
            atcButton.disabled = false;
          });
      });
    }

    // --- General Close Actions ---
    document.querySelectorAll('[data-drawer-close], [data-size-chart-close]').forEach((btn) => {
      btn.addEventListener('click', closeAllDrawers);
    });

    // --- Product Info Drawer Tab Switching ---
    const tabBtns = document.querySelectorAll('.product-drawer__tab-btn');
    const tabPanels = document.querySelectorAll('.product-drawer__tab-panel');

    tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tabTarget;

        // Update buttons
        tabBtns.forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');

        // Update panels
        tabPanels.forEach((panel) => {
          if (panel.dataset.tabPanel === target) {
            panel.classList.add('active');
          } else {
            panel.classList.remove('active');
          }
        });
      });
    });

    // --- Unit Switcher Logic ---
    const unitSwitchers = document.querySelectorAll('[data-unit-switcher]');
    unitSwitchers.forEach((switcher) => {
      switcher.addEventListener('click', (e) => {
        const btn = e.target.closest('.unit-btn');
        if (!btn) return;

        const unit = btn.dataset.unit;

        // Update switcher buttons
        switcher.querySelectorAll('.unit-btn').forEach((b) => b.classList.toggle('active', b === btn));

        // Update rows
        document.querySelectorAll('[data-unit-row]').forEach((row) => {
          row.style.display = row.dataset.unitRow === unit ? 'table-row' : 'none';
        });

        // Update content blocks
        document.querySelectorAll('[data-unit-content]').forEach((content) => {
          content.style.display = content.dataset.unitContent === unit ? 'block' : 'none';
        });

        // Persist preference
        localStorage.setItem('preferredUnit', unit);
      });
    });

    // Restore unit preference
    const savedUnit = localStorage.getItem('preferredUnit');
    if (savedUnit) {
      const activeBtn = document.querySelector(`[data-unit-switcher] .unit-btn[data-unit="${savedUnit}"]`);
      if (activeBtn) activeBtn.click();
    }

    const continueShoppingBtn = document.querySelector('.cart-drawer__continue-btn');
    if (continueShoppingBtn) {
      continueShoppingBtn.addEventListener('click', () => {
        sessionStorage.setItem('cartDrawerDismissed', 'true');
        closeAllDrawers();
      });
    }

    if (backdrop) backdrop.addEventListener('click', closeAllDrawers);

    // Add backdrop for cart if not handled
    const cartBackdropElement = document.querySelector('.cart-drawer-backdrop');
    if (cartBackdropElement) cartBackdropElement.addEventListener('click', closeAllDrawers);

    // --- Gallery Zoom Effect ---
    const galleryImages = document.querySelectorAll('.product__main-image');
    galleryImages.forEach((img) => {
      img.addEventListener('mousemove', (e) => {
        const { left, top, width, height } = img.getBoundingClientRect();
        const x = ((e.pageX - left - window.scrollX) / width) * 100;
        const y = ((e.pageY - top - window.scrollY) / height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = 'scale(1.5)';
      });
      img.addEventListener('mouseleave', () => {
        img.style.transform = 'scale(1)';
        img.style.transformOrigin = 'center center';
      });
    });

    // --- Accordions: single-open behavior ---
    (function () {
      const accordions = Array.from(document.querySelectorAll('.product__accordion'));
      if (!accordions.length) return;
      accordions.forEach((acc) => {
        acc.addEventListener('toggle', () => {
          if (!acc.open) return;
          // Close other accordions
          accordions.forEach((other) => {
            if (other !== acc && other.open) other.open = false;
          });
        });
      });
    })();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.recently-viewed');
    if (!section) return;

    const grid = section.querySelector('[data-recently-viewed-grid]');
    const container = section.querySelector('.recently-viewed__container');
    const limit = parseInt(section.dataset.limit) || 4;
    const currentProductId = section.dataset.productId;

    function getRecentlyViewed() {
      const viewed = localStorage.getItem('recentlyViewed');
      return viewed ? JSON.parse(viewed) : [];
    }

    function setRecentlyViewed(handle) {
      let viewed = getRecentlyViewed();
      viewed = viewed.filter((h) => h !== handle);
      viewed.unshift(handle);
      viewed = viewed.slice(0, 10); // Keep last 10
      localStorage.setItem('recentlyViewed', JSON.stringify(viewed));
    }

    // Capture current product if on product page
    const currentHandle = window.location.pathname.split('/').pop();
    if (window.location.pathname.includes('/products/')) {
      setRecentlyViewed(currentHandle);
    }

    async function renderRecentlyViewed() {
      const viewed = getRecentlyViewed().filter((h) => h !== currentHandle);
      if (viewed.length === 0) return;

      container.style.display = 'block';

      const productsToFetch = viewed.slice(0, limit);

      for (const handle of productsToFetch) {
        try {
          const response = await fetch(`/products/${handle}.js`);
          const product = await response.json();

          const card = document.createElement('div');
          card.className = 'product-card';
          card.innerHTML = `
            <a href="${product.url}" class="product-card__link">
              <div class="product-card__image-wrapper">
                <img src="${product.featured_image}" class="product-card__image" alt="${product.title}" loading="lazy">
              </div>
              <div class="product-card__info">
                <h3 class="product-card__title">${product.title}</h3>
                <div class="product-card__price">
  ${
    product.compare_at_price > product.price
      ? `<span class="price--sale">${Shopify.formatMoney(product.price)}</span>
       <span class="price--original">${Shopify.formatMoney(product.compare_at_price)}</span>`
      : `<span class="price--regular">${Shopify.formatMoney(product.price)}</span>`
  }
</div>
              </div>
            </a>
          `;
          grid.appendChild(card);
        } catch (e) {
          console.error('Error fetching recently viewed product:', e);
        }
      }
    }

    renderRecentlyViewed();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (function() {
      const wrapper = document.querySelector('.stl-carousel-wrapper');
      if (!wrapper) return;
      
      const carousel = wrapper.querySelector('[data-stl-carousel]');
      const prevBtn = wrapper.querySelector('[data-stl-prev]');
      const nextBtn = wrapper.querySelector('[data-stl-next]');
      
      if (carousel && prevBtn && nextBtn) {
          prevBtn.addEventListener('click', () => {
              const cardWidth = carousel.querySelector('.stl-card').offsetWidth;
              carousel.scrollBy({ left: -(cardWidth + 16), behavior: 'smooth' }); // Width + gap
          });
          
          nextBtn.addEventListener('click', () => {
              const cardWidth = carousel.querySelector('.stl-card').offsetWidth;
              carousel.scrollBy({ left: (cardWidth + 16), behavior: 'smooth' });
          });
      }
  })();

  } catch(e) { console.error(e); }
})();
})();
